import React from 'react'
import Navbar from './NavBar'
import './styles.css'
import Container from './Container'
import Section from './Section'
import Testimonials from './Testimonials'
import FAQ from './FAQ'
import Footer from './Footer'

const Home = () => {
return (
    <div className='home'>
        <Navbar/>
        <Container/>
        <Section/>
        <Testimonials/>
        <FAQ/>
        <Footer/>
    </div>
)
}

export default Home